import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';
import {ConfigurationService} from '../../../configuration/configuration.service';
import {Url} from '../../../../core/models/url';
import {DocumentSearchResultService} from '../../../../core/redux/search-result/service/document-search-result.service';
import {EntitySearchResultService} from '../../../../core/redux/search-result/service/entity-search-result.service';
import {GedCfgFieldService} from '../../../../core/redux/field/service/ged/ged-cfg-field.service';
import {AbstractAutocompletionService} from './abstract-autocompletion.service';
import {Field} from '../../../../core/models/field';
import {selectGedCfgFieldDatas} from '../../../../core/redux/field/field-selectors';
import {Store} from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class GedAutocompletionService extends AbstractAutocompletionService {

  gedCfgFields$: Observable<{ [key: string]: Field }> = this.store.select(selectGedCfgFieldDatas);

  constructor(
    http: HttpClient,
    translateService: TranslateService,
    configAction: ConfigurationService,
    private documentSearchResultService: DocumentSearchResultService,
    private entitySearchResultService: EntitySearchResultService,
    private gedCfgFieldService: GedCfgFieldService,
    private store: Store
  ) {
    super(http, translateService, configAction);
    this.apiAutocompleteByKeyword = Url.getProtectedApiBaseUrl(this.configAction) + Url.AUTOCOMPLETE_KEYWORD;
    this.apiAutocompleteByValue = Url.getProtectedApiBaseUrl(this.configAction) + Url.AUTOCOMPLETE_VALUE;
    this.apiAutocompleteByKeyValue = Url.getProtectedApiBaseUrl(this.configAction) + Url.AUTOCOMPLETE_KEY_VALUE;
    this.apiAutocompleteAggregateByKeyword = Url.getProtectedApiBaseUrl(this.configAction) + Url.AUTOCOMPLETE_AGGREGATE;
  }

  protected getApiBaseUrl(): string {
    return Url.getProtectedApiBaseUrl(this.configAction);
  }

  protected getCfgFieldService(): GedCfgFieldService {
    return this.gedCfgFieldService;
  }

  protected getCurrentSearchResultService(entityType: string): DocumentSearchResultService | EntitySearchResultService {
    return entityType ? this.entitySearchResultService : this.documentSearchResultService;
  }

  protected getCfgConfigStore(): Observable<{ [key: string]: Field }> {
    return this.gedCfgFields$;
  }
}
